import React from 'react';
import { motion } from 'framer-motion';
import { Send, Globe, ArrowRight } from 'lucide-react';
export function BookingCTA() {
  return <section id="contact" className="py-24 bg-[#1a1a2e] relative overflow-hidden" data-id="element-10">
      {/* Decorative circles */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-[#c9a96e] rounded-full mix-blend-overlay filter blur-3xl opacity-10 transform translate-x-1/2 -translate-y-1/2" data-id="element-11" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#8b2252] rounded-full mix-blend-overlay filter blur-3xl opacity-10 transform -translate-x-1/2 translate-y-1/2" data-id="element-12" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-14">
          <h2 className="text-4xl md:text-6xl font-serif font-bold text-white mb-6" data-id="element-15">
            立即预约您的<span className="text-[#c9a96e]" data-id="element-16">专属体验</span>
          </h2>
          <p className="text-xl text-gray-300 mb-10 font-light" data-id="element-17">
            Book Your Exclusive Experience Now
          </p>

          <div className="flex flex-col sm:flex-row gap-6 justify-center" data-id="element-18">
            <a href="https://t.me/gl777net" target="_blank" rel="noopener noreferrer" className="group flex items-center justify-center gap-3 px-8 py-4 bg-[#0088cc] text-white rounded-sm hover:bg-[#0077b5] transition-all duration-300 shadow-lg shadow-blue-900/20" data-id="element-19">
              <Send size={20} data-id="element-20" />
              <span className="font-semibold" data-id="element-21">Telegram 预约</span>
              <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" data-id="element-22" />
            </a>

            <a href="https://www.geylang777-2.site" target="_blank" rel="noopener noreferrer" className="group flex items-center justify-center gap-3 px-8 py-4 bg-[#c9a96e] text-[#1a1a2e] rounded-sm hover:bg-[#d4af37] transition-all duration-300 shadow-lg shadow-yellow-900/20" data-id="element-23">
              <Globe size={20} data-id="element-24" />
              <span className="font-semibold" data-id="element-25">访问官网</span>
              <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" data-id="element-26" />
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}